import React from "react";
import "./register.css";
import { Navbar } from "reactstrap";
import { withRouter } from "react-router-dom";

const Thankyou = (props) => {
  const { user } = props.location.state || {};

  const handleNavigation = () => {
    window.location.href = "/";
  };
  return (
    <React.Fragment>
      <Navbar className={"NavBar"}>
        <div onClick={handleNavigation}>
          <img src="/SAR-Logo-White.png" className={"SARLogo"} alt="SAR" />
        </div>
      </Navbar>
      <div className={"NavDivider"} />
      <div className="congratulations-container">
        <h2 className="congratulations-header">
          Thankyou, {user.firstName} {user.lastName} !!
        </h2>
        <div className="congratulations-content">
          Thank you for your enquiry. We will contact you shortly
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Thankyou);



// WEBPACK FOOTER //
// ./src/components/Register/thankyou.jsx